//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "header.menu"
  ,
  data() {
    return {
      ads_69av: this.get_ads('69av'),
      ads_xyg: this.get_ads('xyg'),
      ads_nnn: this.get_ads('vpn'),
    }
  }
}
